import { useEffect } from "react";
import Lenis from "lenis";

/**
 * SmoothScroll — mounts a Lenis smooth-scroll instance and exposes it via
 * window.__lenis so other modules (namely ScrollToTop) can programmatically
 * jump the viewport to the top on route change. Without this hook, calling
 * window.scrollTo(0,0) while Lenis is running is silently ignored — that was
 * causing new pages to sometimes open at the footer.
 */
export default function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => { lenis.destroy(); if (window.__lenis === lenis) window.__lenis = null; };
  }, []);
  return null;
}
